
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import SearchTable3 from "components/Tables/SearchTable3";
import React from "react";
import { IoIosArrowDown } from "react-icons/io";
import { ClientColumn } from "variables/columnsData";
// import tableData2 from "variables/tableData2.json";
import tableData3 from "variables/tableData3.json";

function CustomerList({handleAddClient,handleEdit,handleDelete}) {
   
      
  return (
    <Flex direction="column" pt={{ sm: "125px", md: "75px" }}>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        w="100%"
        mb="24px"
      >
        <Button
          variant="no-hover"
          bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
          w="125px"
          h="35px"
          color="#fff"
          fontSize="xs"
          fontWeight="bold"
          alignSelf={{ sm: "flex-start", lg: null }}
          mb={{ sm: "12px", md: "0px" }}
          onClick={handleAddClient}
        >
          Add Client
        </Button>
        <Stack
          direction="row"
          spacing="10px"
          alignSelf={{ sm: "flex-start", lg: "auto" }}
        >
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<IoIosArrowDown />}
              color="gray.700"
              w="125px"
              h="35px"
              bg="#fff"
              fontSize="xs"
            >
              ΦΙΛΤΡΑ
            </MenuButton>
            <MenuList>
              <MenuItem color="gray.500">Status: Paid</MenuItem>
              <MenuItem color="gray.500">Status: Refunded</MenuItem>
              <MenuItem color="gray.500">Status: Canceled</MenuItem>
              <MenuDivider />
              <MenuItem color="red.300">Remove filter</MenuItem>
            </MenuList>
          </Menu>
          <Button
            variant="no-hover"
            bg="#fff"
            w="125px"
            h="35px"
            color="gray.700"
            fontSize="xs"
            fontWeight="bold"
          >
            ΕΞΑΓΩΓΗ
          </Button>
        </Stack>
      </Flex>
      <Card px="0px">
        <CardBody>
          {/* <SearchTable2 tableData={tableData2} columnsData={columnsData2} /> */}
          <SearchTable3 tableData={tableData3} columnsData={ClientColumn}  onEdit={handleEdit} 
      onDelete={handleDelete} />
        </CardBody>
      </Card>
    </Flex>
  );
}

export default CustomerList;
